import { Button } from 'reactstrap'
import descriptionDefaultValue from './descriptionValue'

import { Read } from '../../../../Editor'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
const Description = (props) => (
	<div className='mng-checklist_description position-relative'>
		<div style={{ position: 'absolute', right: 0, top: '4px' }}>
			<Button
				color='info'
				outline
				size='sm'
				onClick={() => props.editSection('description')}
			>
				<FontAwesomeIcon icon={faEdit} />
			</Button>
		</div>
		<div className='quiz-row-wrapper richEditorStyles col-9 px-0'>
			<Read
				content={
					props.checklist.description &&
					Object.keys(props.checklist.description).length
						? props.checklist.description
						: descriptionDefaultValue
				}
			/>
		</div>
	</div>
)

export default Description
